import { toast } from "@zerodevx/svelte-toast";
export class Toast {
    constructor() {
        // PARAMETER =======================================
        this.totalToastShowed = 5;
        // =================================================
        this.lastId = 1;
    }
    /**
     * Show a success toast (green theme)
     * @param msg
     * @param duration [milliseconds]
     */
    success(msg = "Succès", duration = 2000) {
        this.lastId = toast.push(msg, {
            duration,
            theme: {
                '--toastBackground': '#48BB78',
                '--toastBarBackground': '#2F855A',
                '--toastBarHeight': '2px'
            }
        });
        this.removeToast();
    }
    /**
     * Show an error toast (red theme)
     * @param msg
     * @param duration [milliseconds]
     */
    error(msg = "error", duration = 2000) {
        this.lastId = toast.push(msg, {
            duration,
            theme: {
                '--toastBackground': '#F56565',
                '--toastBarBackground': '#C53030',
                '--toastBarHeight': '2px'
            }
        });
        this.removeToast();
    }
    // PRIVATE ==========================================
    /**
     * Remove que X lasted toast
     * @private
     */
    removeToast() {
        if (this.lastId - this.totalToastShowed > 0) {
            toast.pop(this.lastId - this.totalToastShowed);
        }
    }
}
